class ModalNames {
  static readonly PinLogin: string = 'PinLoginModal';

  static readonly Foreman = class {
    static readonly Delete: string = 'ForemanDeleteModal';
  };

  static readonly Movement = class {
    static readonly Delete: string = 'MovementDeleteModal';
  };
}

export default ModalNames;
